export default __webpack_public_path__ + "static/media/background_winch_truck.f825f989.svg";